import React from 'react';
import ProgressBar from '@24i/nxg-sdk-gluons/src/components/ui/ProgressBar';
import { Text } from '@24i/nxg-sdk-quarks';
import { useTheme } from '@24i/nxg-sdk-higgs';

import { DETAILS_SCREEN_TEST_IDS } from '../../../test-utils';
import { DetailsProgressBarViewProps } from '../types';
import getDetailsProgressBarStyles from '../styles';

const DetailsProgressBar = ({
    isLive,
    episodeToWatch,
    progress,
    styles: getStyles = getDetailsProgressBarStyles,
}: DetailsProgressBarViewProps) => {
    const { theme } = useTheme();
    const styles = getStyles(theme, isLive);

    return (
        <>
            <ProgressBar
                testID={DETAILS_SCREEN_TEST_IDS.PROGRESS_BAR}
                additionalTrackStyles={styles.progressBarTrack}
                additionalProgressStyles={styles.progressContainer}
                progress={progress}
                theme={theme}
            />
            {episodeToWatch && (
                <Text style={styles.progressText}>
                    {`S${episodeToWatch.seasonNumber} E${episodeToWatch.episodeNumber} - ${episodeToWatch.title}`}
                </Text>
            )}
        </>
    );
};

export default DetailsProgressBar;
